import { setContext } from '@apollo/client/link/context'
import { getToken } from '../../utils/tokens'

export const createContextLink = function createContextLink() {
  return setContext(() => ({
    headers: {
      authorization: `Token ${getToken() ?? ''}`,
    },
  }))
}
